import React from 'react'
import { Card } from 'react-bootstrap'
import { DeleteBoardItem } from './DeleteBoardItem'
import { ProductCardLarge } from '../../../../components/Product/ProductCardLarge'

export const BoardItemProduct = ({ product, board, boardItemId }) => {
  return (
    <Card>
      <ProductCardLarge
        {...{
          ...product,
        }}
      />

      <Card.Footer>
        <DeleteBoardItem _id={boardItemId} product={product} board={board} />
      </Card.Footer>
    </Card>
  )
}
